import { Button, Menu, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { DeveloperMode as JsonIcon, Description as HtmlIcon, Description as CsvIcon } from '@material-ui/icons';
import { withStyles } from 'material-ui/styles';
import * as PropTypes from 'prop-types';
import React, { Component } from 'react';


const styles = (theme) => ({
  marginLeft: {
    marginLeft: theme.spacing.unit,
  },
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  },
});


class MyActivityReportMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
    };
  }

  handleOpen = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const { anchorEl } = this.state;
    const {
      classes,
      id,
      reports,
      handleViewCsv,
      handleViewHtml,
      handleViewJson,
    } = this.props;

    return (
      <React.Fragment>
        <Button
          aria-owns={anchorEl ? id : null}
          aria-haspopup="true"
          onClick={this.handleOpen}
          variant="outlined"
        >
          View
        </Button>
        <Menu
          id={id}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          disableAutoFocusItem
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          getContentAnchorEl={null}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
          style={{ marginLeft: 8, marginTop: -3 }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Report Type</TableCell>
                <TableCell colSpan={2}>Formats</TableCell>
              </TableRow>
            </TableHead> 
            <TableBody>
              {
                reports && reports.map((item) => (
                  <TableRow key={`${item.requestId}-${Math.round((new Date()).getTime() / 1000)}`} className={classes.row}>
                    <TableCell component="th" scope="row">
                      <Typography variant="button">{item.reportType}</Typography>
                    </TableCell>
                    <TableCell>
                      {
                        item.htmlKey && (
                          <Button
                            color="primary"
                            variant="contained"
                            onClick={() => {
                              handleViewHtml(item);

                              this.handleClose();
                            }}
                          >
                            HTML <HtmlIcon className={classes.marginLeft} />
                          </Button>
                        )
                      }
                      {
                        item.csvKey && (
                          <Button
                            color="primary"
                            variant="contained"
                            onClick={() => {
                              handleViewCsv(item);

                              this.handleClose();
                            }}
                          >
                            CSV <CsvIcon className={classes.marginLeft} />
                          </Button>
                        )
                      }
                    </TableCell>
                  </TableRow>
                ))
              }
            </TableBody>
          </Table>
        </Menu>
      </React.Fragment>
    );
  }
}

MyActivityReportMenu.propTypes = {
  id: PropTypes.string.isRequired,
  reports: PropTypes.array.isRequired,
  handleViewCsv: PropTypes.func,
  handleViewHtml: PropTypes.func,
  handleViewJson: PropTypes.func,
  style: PropTypes.object,
};

export default withStyles(styles, { name: 'MyActivityReportMenu' })(MyActivityReportMenu);


// WEBPACK FOOTER //
// ./src/components/Account/MyActivityReportMenu.js